/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getRecipes } from 'app/entities/recipe/recipe.reducer';
import { createEntity, getEntity, reset, updateEntity } from './nutrtion.reducer';

export const NutrtionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const recipes = useAppSelector(state => state.recipe.entities);
  const nutrtionEntity = useAppSelector(state => state.nutrtion.entity);
  const loading = useAppSelector(state => state.nutrtion.loading);
  const updating = useAppSelector(state => state.nutrtion.updating);
  const updateSuccess = useAppSelector(state => state.nutrtion.updateSuccess);

  const handleClose = () => {
    navigate(`/nutrtion${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getRecipes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.total !== undefined && typeof values.total !== 'number') {
      values.total = Number(values.total);
    }
    if (values.dailyTotal !== undefined && typeof values.dailyTotal !== 'number') {
      values.dailyTotal = Number(values.dailyTotal);
    }

    const entity = {
      ...nutrtionEntity,
      ...values,
      reciepe: recipes.find(it => it.id.toString() === values.reciepe?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...nutrtionEntity,
          reciepe: nutrtionEntity?.reciepe?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.nutrtion.home.createOrEditLabel" data-cy="NutrtionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.nutrtion.home.createOrEditLabel">Create or edit a Nutrtion</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="nutrtion-id"
                  label={translate('tinyMedicRestApp.nutrtion.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.nutrtion.tmLabel')}
                id="nutrtion-tmLabel"
                name="tmLabel"
                data-cy="tmLabel"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutrtion.tag')}
                id="nutrtion-tag"
                name="tag"
                data-cy="tag"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutrtion.description')}
                id="nutrtion-description"
                name="description"
                data-cy="description"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutrtion.total')}
                id="nutrtion-total"
                name="total"
                data-cy="total"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutrtion.rdi')}
                id="nutrtion-rdi"
                name="rdi"
                data-cy="rdi"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutrtion.dailyTotal')}
                id="nutrtion-dailyTotal"
                name="dailyTotal"
                data-cy="dailyTotal"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutrtion.unit')}
                id="nutrtion-unit"
                name="unit"
                data-cy="unit"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                id="nutrtion-reciepe"
                name="reciepe"
                data-cy="reciepe"
                label={translate('tinyMedicRestApp.nutrtion.reciepe')}
                type="select"
              >
                <option value="" key="0" />
                {recipes
                  ? recipes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/nutrtion" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default NutrtionUpdate;
